class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    // Event Delegation for the header cart icon (robust against AJAX replacements)
    document.addEventListener('click', (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');
      if (cartLink) {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(opener) {
    if (opener) this.opener = opener;
    this.classList.add('active');
    const cartDrawerEl = this.querySelector('.cart-drawer');
    cartDrawerEl.classList.add('active');
    document.body.classList.add('overflow-hidden');

    // Notify DockManager so its outside-click logic knows what's open
    if (window.dockManager) {
      window.dockManager.registerOpen(cartDrawerEl);
    }

    const container = this.querySelector('.cart-drawer__inner');
    const focusableElements = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    // Accessibility
    this.setAttribute('aria-hidden', 'false');

    // Trap Focus Logic
    this.focusTrapHandler = (e) => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      if (!isTabPressed) return;

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    };

    this.addEventListener('keydown', this.focusTrapHandler);

    // Initial focus
    this.querySelector('.cart-drawer__close').focus();
  }

  close() {
    this.classList.remove('active');
    this.querySelector('.cart-drawer').classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    // Sync DockManager state
    if (window.dockManager) {
      window.dockManager.openModal = null;
      document.body.classList.remove('dock-open');
    }

    // Remove Trap Listener
    this.removeEventListener('keydown', this.focusTrapHandler);

    // Accessibility: Move focus BEFORE hiding
    if (this.opener && this.opener.isConnected) {
      this.opener.focus();
    }

    // Safety check: If focus is STILL inside the drawer (e.g. opener was hidden/invalid), force blur
    // This prevents "aria-hidden on focused element" warning
    if (document.activeElement && this.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    // Accessibility: Set Hidden
    this.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
